export const TAG = "#4CAF50";
export const SECTION = "#DBC500";
export const REPEATING_CONTENT_BLOCK = "#204EF3";
export const REPEATING_TABLE_BLOCK = "#55AEF6";
export const CONTENT_BLOCK = "#F7776E";
export const HTML_CONTENT_BLOCK = "#148A4D";
export const DICTATION_CONTENT_BLOCK = "#A54A9C";